export const DEFAULT_STORE = 'Utrecht';
